import { createContext } from 'react';
import type { DemoRole } from '@/lib/demo/constants';

export interface DemoPerson {
  id: string;
  name: string;
  email: string;
}

export interface DemoContextValue {
  isDemoMode: boolean;
  role: DemoRole | null;
  person: DemoPerson | null;
  /** Bumped by resetDemo so consumers can remount a stale tree. */
  resetNonce: number;
  enterDemo: (role: DemoRole) => void;
  /** Secondary "see the other side" affordance — see DemoBanner. */
  switchRole: (role: DemoRole) => void;
  exitDemo: () => void;
  resetDemo: () => void;
}

export const DemoContext = createContext<DemoContextValue | undefined>(undefined);
